import { useCallback, useMemo } from 'react'
import { UserOs } from '../store/Constants'
import { handleUserAgentData } from '../utils/handleUserAgentData'

export const WINDOWS_11_OS = 'windows11'

const useSoftwareOs = (os) => {
  const normalizedOs = os?.toLowerCase()
  const shouldDetectWindows11 =
    normalizedOs?.includes(UserOs.windows) && normalizedOs !== WINDOWS_11_OS

  const windows11Response = useMemo(() => {
    if (!shouldDetectWindows11) {
      return Promise.resolve(false)
    }
    return handleUserAgentData().isWindows11()
  }, [shouldDetectWindows11])

  return useCallback(async () => {
    if (shouldDetectWindows11 && (await windows11Response)) {
      return WINDOWS_11_OS
    }
    return os
  }, [os, shouldDetectWindows11, windows11Response])
}

export default useSoftwareOs
